import React from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const EditQuestionModal = ({ item, onClose, onSubmit }) => {
  let modalTitle;
  let modalContent;
  let modalSubmitButtonText;
  let modalCloseButtonText = '';

  const { values } = Object;
  let { used_detail: usageDetail } = item;
  if (typeof usageDetail === 'string') usageDetail = JSON.parse(usageDetail);
  const hasInProgressAssignments = values(usageDetail).some(
    ({ in_progress }) => in_progress || false,
  );

  if (!hasInProgressAssignments) {
    modalTitle = 'Edit Question';
    modalContent =
      'Any edits you make to this question will be applied everywhere this question appears.';
    modalSubmitButtonText = 'Continue Editing';
    modalCloseButtonText = 'Cancel';
  } else {
    modalTitle = 'Already In Progress';
    modalContent =
      'You cannot edit a question in an assessment that any student has started or completed, or that is currently open to students.';
    modalSubmitButtonText = 'Close';
  }

  return (
    <ConfirmDialog
      size="tiny"
      title={modalTitle}
      onClose={onClose}
      onSuccess={() => (hasInProgressAssignments ? onClose() : onSubmit())}
      content={{
        btnPrimary: modalSubmitButtonText,
        btnSecondary: modalCloseButtonText,
      }}
    >
      <p>{modalContent}</p>
    </ConfirmDialog>
  );
};

export default EditQuestionModal;
